import React from "react";

import { S } from "@puzzle/theme";

import { GrossMargin, NetMargin } from "graphql/types";
import { EmptyGraph, EmptyGraphVariant } from "./EmptyGraph";
import { PercentageLineGraph } from "./PercentageLineGraph";
import { BasicGraphTileContainer } from "./BasicGraphTileContainer";
import Calculating from "./Calculating";
import LoadingMetrics from "./LoadingMetrics";

export const MarginTile = ({
  title,
  toolTipTitle,
  loading,
  data = [],
  ingesting,
  isGraphFeatureGated,
}: {
  title: string;
  toolTipTitle: string;
  loading: boolean;
  data?: GrossMargin[] | NetMargin[];
  ingesting?: boolean;
  isGraphFeatureGated?: boolean;
}) => {
  const mappedData = data.map((x: GrossMargin | NetMargin) => {
    return {
      date: `${x.month}-01`,
      amount: x.amount,
    };
  });

  let formattedValue: string | undefined = undefined;
  const hasData = data && data.length >= 0;
  if (hasData) {
    const lastValue = data[data.length - 1]?.amount;
    formattedValue = lastValue ? `${Math.round(parseFloat(lastValue))}%` : "";
  }

  const hasAllNothing = mappedData.every(
    (x) => x.amount === "0" || x.amount === undefined || x.amount === null
  );

  return (
    <BasicGraphTileContainer
      title={title}
      valueString={formattedValue}
      isFeatureGated={isGraphFeatureGated}
      initialIngestOngoing={ingesting}
    >
      {ingesting ? (
        <>
          <Calculating css={{ marginLeft: "$2" }} />
          <EmptyGraph variant={EmptyGraphVariant.SOLID} />
        </>
      ) : loading ? (
        <div style={{ paddingLeft: S.$2 }}>
          <LoadingMetrics />
        </div>
      ) : hasAllNothing ? (
        <EmptyGraph variant={EmptyGraphVariant.SOLID} text="No revenue in the last 6 months" />
      ) : (
        <PercentageLineGraph inData={mappedData} innerHeight="80%" toolTipLabel={toolTipTitle} />
      )}
    </BasicGraphTileContainer>
  );
};
